import firebase from "firebase";
import items from './items.json';

const firebaseConfig = {
	apiKey: "AIzaSyBwBoRVi-10Xlh_F90Ud5AmZPJSyh80l04",
	authDomain: "kolu-v2.firebaseapp.com",
	databaseURL: "https://kolu-v2.firebaseio.com",
	projectId: "kolu-v2",
	storageBucket: "kolu-v2.appspot.com",
	messagingSenderId: "904940067182",
	appId: "1:904940067182:web:3f90c32b5830272dcd497f",
	measurementId: "G-T163XBPXC3"
};

// Initialize Firebase
const fApp = firebase.initializeApp(firebaseConfig);

const db = fApp.firestore();
export { db };

const functions = fApp.functions("europe-west1");
export { functions };

const logout = () => {
	firebase
		.auth()
		.signOut()
		.then(
			function () {
				console.log("Succesful log out");
			},
			function (error) {
				console.log("Caught error");
				console.log(error.code);
				console.log(error.message);
			}
		);
}

export { logout };

function addAircoItem(item) {
	// console.log(item);
	db.collection("airco_items")
		.doc(item.id)
		.set(item)
		.then(function () {
			console.log("Airco item succesfully added !");
		})
		.catch(function (error) {
			console.error("Error adding Airco Item ", error);
		});
}

function parseID(id) {
	let result = { model: "", merk: "", aantalKamers: null, opp: null };
	//Handle model and merk
	result.model = id.slice(0, 3);
	result.merk = id.slice(1, 3);
	//Handle Split aircos
	if (id[0] === "S") {
		result.aantalKamers = 1;
		result.opp = Number(id.slice(3, id.length).split("-")[0]);
	} else {
		//Handle Multi aircos
		result.aantalKamers = Number(id[3]);
		result.opp = Number(id.slice(3, id.length).split("-")[1]);
	}
	return result;
}

function parseAircoItem(item) {
	return {
		naam: item.Naam,
		id: item.ID,
		btw: item.Btw,
		prijs: item.Prijs,
		beschrijving: item.Beschrijving,
		...parseID(item.ID)
	};
}

export function addAllAircoItems() {
	items.filter((doc) => {
		const model = doc.ID.substr(0, 3);
		return ['SDA', 'MDA', 'SLG', 'MLG'].includes(model);
	}).map(item => parseAircoItem(item)).forEach(item => {
		addAircoItem(item);
	});
}

export default firebase;
